import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { useDispatch as useAppDispatch, useSelector as useAppSelector, shallowEqual as useAppShallowEqual } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './slices/user';
import adminReducer from './slices/admin';
import companyReducer from './slices/company';
import storeReducer from './slices/store';
import employeeReducer from './slices/employee';
import employee_positionReducer from './slices/employee_position';
import employee_statusReducer from './slices/employee_status';
import stock_movementReducer from './slices/stock_movement';
import process_listReducer from './slices/process_list';
import marketplace_accountReducer from './slices/marketplace_account';
import marketplace_orderReducer from './slices/marketplace_order';
import marketplace_pull_orderReducer from './slices/marketplace_pull_order';
import marketplace_push_orderReducer from './slices/marketplace_push_order';
import productReducer from './slices/product';
import task_scheduleReducer from './slices/task_schedule';
import turboly_accountReducer from './slices/turboly_account';
import turboly_companyReducer from './slices/turboly_company';
import turboly_storeReducer from './slices/turboly_store';
import turboly_registerReducer from './slices/turboly_register';
import turboly_supplierReducer from './slices/turboly_supplier';
import turboly_salesReducer from './slices/turboly_sales';
import turboly_coaReducer from './slices/turboly_coa';
import turboly_stockReducer from './slices/turboly_stock';
import app_settingsReducer from './slices/app_settings';
import supplierReducer from './slices/supplier';
import expenseReducer from './slices/expense';
import income_invoiceReducer from './slices/income_invoice';
import expense_invoiceReducer from './slices/expense_invoice';
import expense_pushReducer from './slices/expense_push';
import expense_paymentReducer from './slices/expense_payment';
import expense_open_paymentReducer from './slices/expense_open_payment';
import expense_payment_draftReducer from './slices/expense_payment_draft';
import income_paymentReducer from './slices/income_payment';
import bank_statement_listReducer from './slices/bank_statement_list';
import bank_statementReducer from './slices/bank_statement';
import AP_ARReducer from './slices/AP_AR';
import tax_settingReducer from './slices/tax_setting';
import gl_journalReducer from './slices/gl_journal';
import divisionReducer from './slices/division';
import customerReducer from './slices/customer';
import coaReducer from './slices/coa';
import default_coaReducer from './slices/default_coa';

// ----------------------------------------------------------------------
const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  // whitelist: ["user"],
  whitelist: [],
};

const rootReducer = combineReducers({
  user : userReducer,
  admin : adminReducer,
  company : companyReducer,
  store : storeReducer,
  employee : employeeReducer,
  employee_position : employee_positionReducer,
  employee_status : employee_statusReducer,
  stock_movement : stock_movementReducer,
  process_list : process_listReducer,
  marketplace_account : marketplace_accountReducer,
  marketplace_order : marketplace_orderReducer,
  marketplace_pull_order : marketplace_pull_orderReducer,
  marketplace_push_order : marketplace_push_orderReducer,
  product : productReducer,
  task_schedule : task_scheduleReducer,
  turboly_account : turboly_accountReducer,
  turboly_company : turboly_companyReducer,
  turboly_store : turboly_storeReducer,
  turboly_register : turboly_registerReducer,
  turboly_supplier : turboly_supplierReducer,
  turboly_sales : turboly_salesReducer,
  turboly_coa : turboly_coaReducer,
  turboly_stock : turboly_stockReducer,
  supplier : supplierReducer,
  expense : expenseReducer,
  income_invoice : income_invoiceReducer,
  expense_invoice : expense_invoiceReducer,
  expense_push : expense_pushReducer,
  expense_payment : expense_paymentReducer,
  expense_open_payment : expense_open_paymentReducer,
  expense_payment_draft : expense_payment_draftReducer,
  income_payment : income_paymentReducer,
  bank_statement_list : bank_statement_listReducer,
  bank_statement : bank_statementReducer,
  app_settings : app_settingsReducer,
  AP_AR : AP_ARReducer,
  tax_setting : tax_settingReducer,
  gl_journal : gl_journalReducer,
  division : divisionReducer,
  customer : customerReducer,
  coa : coaReducer,
  default_coa : default_coaReducer,
});
const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
});

const persistor = persistStore(store);

const { dispatch } = store;
const useSelector = useAppSelector;
const shallowEqual = useAppShallowEqual;
const useDispatch = () => useAppDispatch();

export { store, persistor, dispatch, useSelector, shallowEqual, useDispatch };
// export { store, persistor, dispatch , useDispatch  };
